import { render } from "./Breadcrumbs.vue?vue&type=template&id=6c44b7fc&scoped=true&ts=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=6c44b7fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c44b7fc"]])

export default __exports__